import { FC } from 'react';
import { Content } from '@prismicio/client';

import { TableWrapper } from '../../components';

import { CaliforniaHead } from './CaliforniaHead';

import { CaliforniaBody } from './CaliforniaBody';
import { Simplify } from '../../../prismicio-types';
import { TableContentVariant } from '@/types';

type Props = {
  data: Simplify<Content.PolicyTableSliceCaliforniaPolicyPrimary>;
  variant?: TableContentVariant;
};

export const CaliforniaPolicyTable: FC<Props> = ({
  data,
  variant = 'page',
}) => {
  return (
    <TableWrapper>
      <CaliforniaHead data={data} variant={variant} />
      <CaliforniaBody data={data} variant={variant} />
    </TableWrapper>
  );
};
